// extracted by mini-css-extract-plugin
export default {"container":"TermsPage_container__kzE-n"};